import React from 'react';

import './Scratchpad.less';

export class Scratchpad extends React.Component {
    render() {
        let {label} = this.props;

        return (
            <div className="site-header-scratchpad" data-bypass="true">
                <div className="site-header-scratchpad__label">{label}</div>
            </div>
        );
    }
}
